import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';



const getDepartmentsAsUnits = async (): Promise<IGetDepartmentsAsUnits[]> => {
  return axiosDefaultApi.get(`/api/Departments/GetDepartmentsAsUnits`);
};

type QueryFnType = typeof getDepartmentsAsUnits;

type UseGetDepartmentsAsUnitsOptions = {
  
  config?: QueryConfig<QueryFnType>;
};

export const useGetDepartmentsAsUnits = ({ config }: UseGetDepartmentsAsUnitsOptions ) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: ['getDepartmentsAsUnits'],
    queryFn: () => getDepartmentsAsUnits(),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των δεδομένων.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};